import {
  BalanceIcon,
  CloseIcon,
  SuccessIcon,
  WarningIcon,
} from '../../assets/svg/StatusIcon';
import {renderDescriptionParagraphs} from '@rb-serve-app/core';

interface ErrorProps {
  errorText?: string | null;
  fontSize?: string | null;
  onClose?: () => void;
  error?: boolean;
  oncloseHide?: boolean;
  banner?: boolean;
  bannerText?: string;
}

const InlineError: React.FC<ErrorProps> = ({
  errorText,
  fontSize,
  onClose,
  error = true,
  oncloseHide = false,
  banner = false,
  bannerText,
}) => {
  return (
    <div
      className={`flex  ${banner ? 'justify-between' : 'justify-center gap-[3%]'} ${banner ? 'items-center' : 'items-start'} px-[15px] py-[10px] ${error ? 'bg-[#FFF6F3]' : 'bg-[#F4FCF7]'}`}
    >
      <div className={`flex w-full gap-[3%] ${banner && 'w-full'}`}>
        {banner ? (
          <div className="" aria-label="warningIcon">
            <WarningIcon width="24" height="24" />
          </div>
        ) : error ? (
          <div className="w-[3%] mt-[6px]" aria-label="balanceIcon">
            <BalanceIcon fill="#DA291C" width="14" height="14" />
          </div>
        ) : (
          <div aria-label="successIcon">
            <SuccessIcon />
          </div>
        )}
        {errorText && (
          <div
            aria-label={errorText}
            className={`${error ? 'text-[#5B1C00]' : 'text-[#003D46]'} ${fontSize} font-500  w-auto`}
          >
            {renderDescriptionParagraphs(errorText)}
          </div>
        )}
        {banner && bannerText && (
          <p
            className={`text-[#003A45] ${fontSize} font-500  w-auto`}
            aria-label={renderDescriptionParagraphs(bannerText , " ", true)}
          >
            {renderDescriptionParagraphs(bannerText)}
          </p>
        )}
      </div>
      {oncloseHide && (
        <div onClick={onClose} aria-label="closeIcon">
          <CloseIcon
            fill={banner ? '#0090AD' : '#DA291C'}
            width="24"
            height="25"
          />
        </div>
      )}
    </div>
  );
};

export default InlineError;
